import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * La tarjeta de la maqueta: bordes redondeados grandes, borde fino y una sombra
 * apenas visible. El radio va explícito acá y no por `--radius`: el radio global
 * es filoso a propósito y no se cambia desde una sola sección.
 */
export function Tarjeta({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-tarjeta border border-border bg-card text-card-foreground shadow-sm',
        className
      )}
      {...props}
    />
  );
}

/** El rótulo chico en mayúsculas de la maqueta («POR ESTRATEGIA», «DÍA A DÍA»). */
export function Rotulo({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <p
      className={cn(
        'text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground',
        className
      )}
    >
      {children}
    </p>
  );
}

/** El título de una tarjeta, en Poppins. */
export function TituloDeTarjeta({
  children,
  className,
  como: Etiqueta = 'h2',
}: {
  children: ReactNode;
  className?: string;
  como?: 'h2' | 'h3';
}) {
  return (
    <Etiqueta className={cn('tracking-tight text-lg font-semibold text-foreground', className)}>
      {children}
    </Etiqueta>
  );
}
